import React from 'react';
import { CustomIcon } from 'components/CustomIcon';
import * as Styles from './ProductCard.styles';
import { ProductCardProps } from './ProductCard.types';

export const TopProductInfo: React.FC<
  Pick<ProductCardProps, 'topInfoItems'>
> = ({ topInfoItems }) => (
  <Styles.ProductInfoContainer top>
    <Styles.ProductInfoText variant="body" component="div" isTopLabel>
      {topInfoItems?.map(({ label, iconName, bgColor, textColor }) => (
        <Styles.FeatureItem
          key={String(label)}
          bgColor={bgColor}
          textColor={textColor}
          isTopLabel
        >
          <p>{label}</p>
          {iconName != null && <CustomIcon size={0.9} dense name={iconName} />}
        </Styles.FeatureItem>
      ))}
    </Styles.ProductInfoText>
  </Styles.ProductInfoContainer>
);
